import './LineSeparator.css'

export function LineSeparator ({ noSpaceTop = false, noSpaceBottom = false }) {
  return (
    <div className={`${noSpaceTop && 'no-space-top'} ${noSpaceBottom && 'no-space-bottom'} container-line-separtor`}></div>
  )
}
